module.exports = __webpack_public_path__ + "static/media/foto 4 José Fachín.12848a2e.jpg";